import { useGetUser } from 'entities/user/api';

/**
 * Hook to get the current board ID from the user's last board.
 *
 * @deprecated use hook from `entities/user/api/hooks/useGetCurrentOrganisationId` instead.
 * @returns {string | undefined} The ID of the last board the user accessed, or undefined if not available.
 */
export const useGetCurrentOrganisationId = () => {
  const { data } = useGetUser();

  // dirty hack PER-3104
  return data?.lastBoard?.organisationId as unknown as number;
};
